import { defineMessages } from 'react-intl';

export default defineMessages({
  title: { id: 'gofre.OldApp.title' },
  text: { id: 'gofre.OldApp.text' },
  androidButton: { id: 'gofre.OldApp.android-button' },
  iosButton: { id: 'gofre.OldApp.ios-button' },
});
